import { GlobalContext } from 'context';
import React, { PropsWithChildren, ReactElement, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ErrorPageProps } from 'shared/domain/error-page';
import useDispatchState from 'shared/hooks/useDispatchState';
import ErrorPage from '../ErrorPage/ErrorPage';

type ErrorPageProviderProps = PropsWithChildren<{
  onGoOut?: (error: ErrorPageProps, history: ReturnType<typeof useLocation>) => void;
  children: ReactElement;
  onError?: (error: ErrorPageProps) => void;
}>;

const ErrorPageProvider: React.FC<ErrorPageProviderProps> = ({ children, onGoOut, onError }: ErrorPageProviderProps): ReactElement => {
  const [{ error }, dispatch] = useDispatchState(GlobalContext);
  const location = useLocation();

  useEffect(() => {
    if (error?.isErrorPage()) {
      if (onGoOut) {
        onGoOut(error.getRawError(), location);
      }
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  useEffect(() => {
    if (error && onError) {
      onError(error.getRawError());
    }
  }, [error]);

  return error?.isErrorPage() ? (
    <ErrorPage
      {...error.getRawError<ErrorPageProps>((err) => ({
        primaryAction: () => {
          const fn = err.primaryAction();
          if (typeof fn === 'function') {
            (fn as unknown as (args: any) => any)(dispatch);
          }
        },
      }))}
    />
  ) : (
    children
  );
};

export default ErrorPageProvider;
